export const iconStyle = {
  maxWidth: 16,
  maxHeight: 16,
  margin: "0 3px 0 2px",
  width: 16,
  height: 16,
};
